import type { ILandingEngagementItem } from "design-system/src/Components/WidgetPart/LandingEngagements/LandingEngagements";
import {
  ILandingStandardWidgetEngagementRepeaterItem,
  ILandingStandardWidgetEngagementsParams,
} from "../interface";

const LEGACY_MAX_SLOTS = 4;

function engagementItemString(
  item: Record<string, unknown>,
  key: string
): string | undefined {
  const value = item[key];
  if (value === undefined || value === null) return undefined;
  const text = String(value).trim();
  return text === "" ? undefined : text;
}

function prepareEngagementsFromRepeaterItems(
  items: ILandingStandardWidgetEngagementRepeaterItem[]
): ILandingEngagementItem[] {
  return items.reduce<ILandingEngagementItem[]>((list, item) => {
    const record = item as Record<string, unknown>;
    const title = engagementItemString(record, "title");
    const imageId = engagementItemString(record, "image");
    if (!title || !imageId) {
      return list;
    }
    list.push({
      title,
      subtitle: engagementItemString(record, "subtitle"),
      imageId,
      url: engagementItemString(record, "link"),
    });
    return list;
  }, []);
}

function prepareEngagementsFromLegacyKeys(
  params: ILandingStandardWidgetEngagementsParams,
  quantity: number = LEGACY_MAX_SLOTS
): ILandingEngagementItem[] {
  const list: ILandingEngagementItem[] = [];
  const rawParams: Record<string, string | undefined> = params as Record<
    string,
    string | undefined
  >;
  Array.from({ length: quantity }, (_value, index) => index + 1).forEach(
    (key) => {
      const title = rawParams[`title_engagement_${key}`];
      const subtitle = rawParams[`subtitle_engagement_${key}`];
      const imageId = rawParams[`image_engagement_${key}`];
      const url = rawParams[`link_engagement_${key}`];

      if (title && imageId) {
        list.push({
          title,
          subtitle,
          imageId,
          url,
        });
      }
    }
  );
  return list;
}

const useEngagements = (params: ILandingStandardWidgetEngagementsParams) => {
  return {
    prepareEngagements(): ILandingEngagementItem[] {
      const rawParams = params as Record<string, unknown>;
      const repeater = rawParams["engagements"];
      if (Array.isArray(repeater)) {
        return prepareEngagementsFromRepeaterItems(
          repeater as ILandingStandardWidgetEngagementRepeaterItem[]
        );
      }
      if (params.template === "engagements-v2") {
        return [];
      }
      return prepareEngagementsFromLegacyKeys(params);
    },
    /** @deprecated Use prepareEngagements() */
    prepareEngaements(quantity: number = LEGACY_MAX_SLOTS): ILandingEngagementItem[] {
      return prepareEngagementsFromLegacyKeys(params, quantity);
    },
  };
};

export default useEngagements;
